(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentAssessControllers')
        .controller('RiskSelfAssessmentPreliminaryQuestionsController', Controller);

    Controller.$inject = ['$scope', '$rootScope', '$state', 'assessmentQuestions', 'risksToAssess', 'authenticatedAssessorID', 'commonRiskSelfAssessmentService'];

    function Controller($scope, $rootScope, $state, assessmentQuestions, risksToAssess, authenticatedAssessorID, riskAssessmentService) {
        $scope.assessmentQuestions = assessmentQuestions;
        $scope.ctrlCtxt = {
            isPageValid: false,
            isValidOnPageLoad: false,
            hasChanged: false,
            isSaving: false
        };
        $scope.originalQuestions = null;

        init();

        $scope.hasAssessmentBeenModified = function () {
            return $scope.ctrlCtxt.hasChanged;
        };

        $scope.answerUpdated = function () {
            $rootScope.$broadcast('page-is-dirty');
            $scope.ctrlCtxt.hasChanged = true;
            checkIfPageIsValid();
        };

        $scope.goToSummary = function () {
            $state.go('riskSelfAssessmentAssess.summary', {}, { reload: true });
        };

        $scope.shouldHideRatingsLegend = function () {
            return true;
        };

        $scope.isPreviousBtnDisabled = function () {
            return true;
        };

        $scope.isNextBtnDisabled = function () {
            return !$scope.ctrlCtxt.isValidOnPageLoad;
        };

        $scope.goToNextPage = function () {
            $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', { RiskID: risksToAssess[0].Risk.RiskID });
        };

        $scope.isSaveAndContinueActionDisabled = function () {
            return $scope.ctrlCtxt.isSaving || !$scope.ctrlCtxt.isPageValid;
        };

        $scope.saveAndContinue = function () {
            if ($scope.ctrlCtxt.isSaving) return;
            $scope.ctrlCtxt.isSaving = true;

            if (!$scope.ctrlCtxt.hasChanged) {
                $scope.goToNextPage();
                return;
            }

            cleanupAnswers($scope.assessmentQuestions.RiskAssessmentQuestions[0]);

            riskAssessmentService
                .updateAssessmentQuestions($scope.assessmentQuestions, authenticatedAssessorID)
                .then(function () {
                    $scope.goToNextPage();
                })
                .finally(function () {
                    $scope.ctrlCtxt.isSaving = false;
                });
        };

        function checkIfPageIsValid() {
            var isValid;

            // Question 1
            var question = $scope.assessmentQuestions.RiskAssessmentQuestions[0];
            isValid = validateQuestion(question);

            $scope.ctrlCtxt.isPageValid = isValid;
        }

        function validateQuestion(question) {
            var isValid = true;
            for(var i=0; i<question.MinMandatoryAnswer; i++) {
                var answer = question.RiskAssessmentAnswers[i];
                if (answer._isMandatory && !answer.AssessorValue) {
                    isValid = false;
                }
            }
            return isValid;
        }

        function cleanupAnswers(question) {
            // Remove empty answers and reassign Depth
            _.remove(question.RiskAssessmentAnswers, function (answer) {
                return !answer.AssessorValue;
            });
            _.each(question.RiskAssessmentAnswers, function (answer, index) {
                answer.Depth = index+1;
            });
        }

        function init() {
            _.each($scope.assessmentQuestions.RiskAssessmentQuestions, function (question) {
                question.RiskAssessmentAnswers = question.RiskAssessmentAnswers || [];
                for (var i=0; i<question.MaxAnswer; i++) {
                    if (!question.RiskAssessmentAnswers[i]) {
                        question.RiskAssessmentAnswers.push(
                            riskAssessmentService.createRiskAssessmentAnswer(question.RiskAssessmentQuestionID, question)
                        );
                    }
                    question.RiskAssessmentAnswers[i]._isMandatory = i < question.MinMandatoryAnswer;
                }
            });
            $scope.originalQuestions = _.cloneDeep($scope.assessmentQuestions);
            checkIfPageIsValid();
            $scope.ctrlCtxt.isValidOnPageLoad = $scope.ctrlCtxt.isPageValid;
        }
    }
})();
